var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkopayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 256,
    viewBox: "0 0 512 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_479_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0H0V256H256V0Z",
    fill: "url(#paint0_linear_479_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5957 87.1489V133.106C92.5957 152.848 77.964 168.851 59.9149 168.851C41.8657 168.851 27.234 152.848 27.234 133.106V87.1489H56.18L45.9088 115.234L59.9149 120.851L48.2431 148.426L81.3911 117.276L66.9178 111.66L76.2553 87.1489H92.5957Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.494 168.851H157.957C156.895 151.293 153.197 138.368 146.948 130.396L144.938 127.832L146.941 125.261C150.197 121.08 152.64 115.679 154.201 109.208C155.615 103.343 156.421 95.9357 156.603 87.1489H139.492C139.217 94.9025 138.099 101.137 136.095 106.126C132.806 114.315 127.725 116.586 124.041 117.048L120.117 117.54V87.1489H103.489V168.851H120.117V135.967L123.822 136.175C136.869 136.906 139.001 157.869 139.494 168.851Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.085 87.1489C178.065 87.1489 163.404 101.195 163.404 118.46V137.54C163.404 154.805 178.065 168.851 196.085 168.851C214.105 168.851 228.766 154.805 228.766 137.54V118.46C228.766 101.195 214.105 87.1489 196.085 87.1489ZM181.021 118.299C181.021 110.426 187.7 104.027 195.917 104.027H196.253C204.47 104.027 211.149 110.426 211.149 118.299V137.701C211.149 145.573 204.47 151.972 196.253 151.972H195.917C187.7 151.972 181.021 145.573 181.021 137.701V118.299Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0H256V256H512V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.03 89.1316H321.285C330.255 89.1316 337.119 91.5118 341.88 96.2724C344.226 98.6183 346.019 101.343 347.261 104.448C348.572 107.484 349.228 110.899 349.228 114.693C349.228 118.35 348.607 121.696 347.365 124.732C346.192 127.767 344.467 130.39 342.19 132.597C339.983 134.736 337.292 136.426 334.118 137.668C330.944 138.841 327.357 139.427 323.355 139.427H304.934V166.128H287.03V89.1316ZM304.934 125.456H319.94C323.666 125.456 326.494 124.491 328.426 122.559C330.427 120.627 331.427 118.005 331.427 114.693C331.427 111.313 330.427 108.725 328.426 106.932C326.494 105.069 323.7 104.138 320.044 104.138H304.934V125.456ZM372.951 89.1316H391.269L419.107 166.128H400.479L395.615 151.432H367.673L362.913 166.128H345.216L372.951 89.1316ZM371.813 138.806H391.579L386.922 124.421C386.094 121.8 385.37 119.281 384.749 116.867C384.128 114.383 383.611 112.175 383.197 110.243C382.713 107.967 382.299 105.863 381.955 103.931H381.748C381.195 106.483 380.644 108.967 380.092 111.382C379.54 113.452 378.954 115.694 378.333 118.109C377.78 120.455 377.194 122.559 376.573 124.421L371.813 138.806ZM437.603 137.358L411.213 89.1316H430.565L438.844 105.276C439.742 107.07 440.638 109.036 441.535 111.175C442.432 113.245 443.26 115.211 444.019 117.074C444.847 119.281 445.675 121.455 446.503 123.594H446.71C447.538 121.455 448.4 119.281 449.297 117.074C450.056 115.211 450.884 113.245 451.781 111.175C452.746 109.036 453.678 107.07 454.575 105.276L462.957 89.1316H481.586L455.196 137.151V166.128H437.603V137.358Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_479_2",
    x1: 0,
    y1: 130.723,
    x2: 250.553,
    y2: 130.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6764D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4964D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_479_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkopayLogo);
export default __webpack_public_path__ + "static/media/UKOPAYLogo.a56481c3f4d0a5b40b86a7895158ad00.svg";
export { ForwardRef as ReactComponent };